import { memo } from 'react';
import { Box, Chip } from '@mui/material';
import { type FilterChip } from './shared.types';

interface ActiveFilterChipsProps {
    /** Array of active filter chips to display */
    chips: FilterChip[];
    /** Called when a chip's delete button is clicked */
    onDelete: (key: string) => void;
    /** Optional: Called to clear all filters */
    onClearAll?: () => void;
    /** Whether to show the "Clear All" chip */
    showClearAll?: boolean;
}

function ActiveFilterChipsComponent({ chips, onDelete, onClearAll, showClearAll = false }: ActiveFilterChipsProps) {
    if (chips.length === 0) {
        return null;
    }

    return (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
            {chips.map(chip => (
                <Chip key={chip.key} label={chip.label} size="small" onDelete={() => onDelete(chip.key)} />
            ))}
            {showClearAll && onClearAll && chips.length > 1 && (
                <Chip
                    label="Clear All"
                    size="small"
                    color="secondary"
                    onClick={onClearAll}
                    onDelete={onClearAll}
                    sx={{ cursor: 'pointer' }}
                />
            )}
        </Box>
    );
}

export const ActiveFilterChips = memo(ActiveFilterChipsComponent);
